import { render, staticRenderFns } from "./merdeka-center-range.vue?vue&type=template&id=2adab537&scoped=true"
import script from "./merdeka-center-range.vue?vue&type=script&lang=js"
export * from "./merdeka-center-range.vue?vue&type=script&lang=js"
import style0 from "./merdeka-center-range.vue?vue&type=style&index=0&id=2adab537&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2adab537",
  null
  
)

export default component.exports